(() => {
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: 'USD'
  }).format(cents / 100);

  function bindOffers() {
    document.querySelectorAll('[data-pp-smartmat-offer]').forEach(root => {
      if (root.dataset.ppSmartmatOfferBound === '1' || root.dataset.ppSmartmatOfferEligible !== '1') return;
      root.dataset.ppSmartmatOfferBound = '1';
      const starts = Number(root.dataset.ppSmartmatOfferStartsAt) * 1000;
      const ends = Number(root.dataset.ppSmartmatOfferEndsAt) * 1000;
      const regular = Number(root.dataset.ppSmartmatRegularPrice);
      const shippingVerified = root.dataset.ppSmartmatFreeShippingVerified === '1';
      if (regular !== 3999 || !Number.isFinite(starts) || !Number.isFinite(ends)) return;
      let timer;
      let previousPrice;

      function sync() {
        window.clearTimeout(timer);
        const now = Date.now();
        const active = shippingVerified && starts > 0 && ends > starts && now >= starts && now < ends;
        const price = active ? Math.round(regular * 0.8) : regular;
        root.querySelectorAll('[data-pp-smartmat-single-price]').forEach(node => { node.textContent = money(price); });
        root.querySelectorAll('[data-pp-smartmat-offer-note]').forEach(node => { node.hidden = !active; });
        root.dataset.ppSmartmatOfferActive = active ? '1' : '0';

        if (root.hasAttribute('data-pp-v22')) {
          root.dataset.basePrice = String(price);
          root.dataset.matPrice = String(price);
          if (price !== previousPrice) root.dispatchEvent(new CustomEvent('pp:smartmat-offer-price-changed'));
        } else {
          const single = root.querySelector('[data-pp-package][value="mat"]');
          if (single) {
            single.dataset.priceCents = String(price);
            single.dataset.subPriceCents = String(price);
            single.dataset.regularCents = String(regular);
          }
          root.dataset.shippingThresholdCents = active ? '0' : root.dataset.ppSmartmatRegularShippingThreshold;
          if (price !== previousPrice) window.PuzzlePupPdpPurchase?.update(root.querySelector('[data-pp-canonical-form]'));
        }
        previousPrice = price;
        const boundary = now < starts ? starts : now < ends ? ends : null;
        if (shippingVerified && boundary !== null) {
          timer = window.setTimeout(sync, Math.min(boundary - now + 250, 2147483000));
        }
      }

      sync();
      window.addEventListener('pageshow', sync);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) sync(); });
    });
  }

  bindOffers();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindOffers, { once: true });
  document.addEventListener('shopify:section:load', bindOffers);
})();
